const columns = [
  {
    title: "Index",
    key: "stt",
    dataIndex: "stt",
    scopedSlots: { customRender: "stt" },
    align: "center",
    width: 50,
  },
  {
    title: "Name",
    key: "name",
    dataIndex: "name",
    scopedSlots: { customRender: "name" },
    sorter: (a, b) => a.name.localeCompare(b.name),
    width: 250,
  },

  {
    title: "Categories",
    key: "categories",
    dataIndex: "categories",
    scopedSlots: { customRender: "categories" },
    width: 200,
  },
  {
    title: "Created At",
    key: "createdAt",
    dataIndex: "createdAt",
    scopedSlots: { customRender: "createdAt" },
    width: 150,
  },
  {
    title: "Updated At",
    key: "updatedAt",
    dataIndex: "updatedAt",
    scopedSlots: { customRender: "updatedAt" },
    width: 150,
  },
  {
    title: "",
    key: "action",
    scopedSlots: { customRender: "action" },
    width: 100,
  },
];

export { columns };
